import BaseService from '../base';
import { NotificationProps } from './types';

class Notification extends BaseService {
  updateNotification() {
    return {
      query: ({ id, ...patch }: NotificationProps) => ({
        url: `/notifications/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: this.tagType }],
    };
  }
}

export default new Notification('notifications', 'Notification');
